import { commentsItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            用户心声
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            来自真实用户的观影体验分享
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-4xl mx-auto">
          {commentsItems.map((comment, idx) => (
            <article
              key={idx}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-800">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {comment.content}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}